// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_Pnq","cls2":"ProfilePdfPackCard-cls2__8p ProfilePdfPackCard-cls1_Pnq"};